"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var react_1 = require("react");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var omit_1 = tslib_1.__importDefault(require("rc-util/lib/omit"));
var config_provider_1 = require("../config-provider");
var NormalEye_1 = require("../Icons/NormalEye");
var NormalEyeClose_1 = require("../Icons/NormalEyeClose");
var Input_1 = tslib_1.__importDefault(require("./Input"));
var ActionMap = {
    click: 'onClick',
    hover: 'onMouseOver',
};
var Password = React.forwardRef(function (props, ref) {
    var _a = tslib_1.__read((0, react_1.useState)(false), 2), visible = _a[0], setVisible = _a[1];
    var onVisibleChange = function () {
        var disabled = props.disabled;
        if (disabled) {
            return;
        }
        setVisible(!visible);
    };
    var getIcon = function (prefixCls) {
        var _a;
        var action = props.action, _b = props.iconRender, iconRender = _b === void 0 ? function () { return null; } : _b;
        var iconTrigger = ActionMap[action] || '';
        var icon = iconRender(visible);
        var iconProps = (_a = {},
            _a[iconTrigger] = onVisibleChange,
            _a.className = "".concat(prefixCls, "-icon"),
            _a.key = 'passwordIcon',
            _a.onMouseDown = function (e) {
                // Prevent focused state lost
                // https://github.com/ant-design/ant-design/issues/15173
                e.preventDefault();
            },
            _a.onMouseUp = function (e) {
                // Prevent caret position change
                // https://github.com/ant-design/ant-design/issues/23524
                e.preventDefault();
            },
            _a);
        return React.cloneElement(React.isValidElement(icon) ? icon : React.createElement("span", null, icon), iconProps);
    };
    var renderPassword = function (_a) {
        var _b;
        var getPrefixCls = _a.getPrefixCls;
        var className = props.className, customizePrefixCls = props.prefixCls, customizeInputPrefixCls = props.inputPrefixCls, size = props.size, visibilityToggle = props.visibilityToggle, restProps = tslib_1.__rest(props, ["className", "prefixCls", "inputPrefixCls", "size", "visibilityToggle"]);
        var inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
        var prefixCls = getPrefixCls('input-password', customizePrefixCls);
        var suffixIcon = visibilityToggle && getIcon(prefixCls);
        var inputClassName = (0, classnames_1.default)(prefixCls, className, (_b = {},
            _b["".concat(prefixCls, "-").concat(size)] = !!size,
            _b));
        var omittedProps = tslib_1.__assign(tslib_1.__assign({}, (0, omit_1.default)(restProps, ['suffix', 'iconRender'])), { type: visible ? 'text' : 'password', className: inputClassName, prefixCls: inputPrefixCls, suffix: suffixIcon });
        if (size) {
            omittedProps.size = size;
        }
        return React.createElement(Input_1.default, tslib_1.__assign({ ref: ref }, omittedProps));
    };
    return React.createElement(config_provider_1.ConfigConsumer, null, renderPassword);
});
Password.defaultProps = {
    action: 'click',
    visibilityToggle: true,
    // eslint-disable-next-line no-confusing-arrow
    iconRender: function (visible) { return (visible ? React.createElement(NormalEye_1.NormalEye, null) : React.createElement(NormalEyeClose_1.NormalEyeClose, null)); },
};
Password.displayName = 'Password';
exports.default = Password;
//# sourceMappingURL=Password.js.map